var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_125_1318)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.396 2.64306C21.817 0.919792 18.7848 0 15.683 0C11.5236 0 7.53458 1.65231 4.59344 4.59344C1.65231 7.53458 0 11.5236 0 15.683C0 18.7848 0.919792 21.817 2.64306 24.396C4.36633 26.9751 6.81568 28.9852 9.68138 30.1722C12.5471 31.3592 15.7004 31.6698 18.7426 31.0647C21.7848 30.4595 24.5793 28.9659 26.7726 26.7726C28.9659 24.5793 30.4595 21.7848 31.0647 18.7426C31.6698 15.7004 31.3592 12.5471 30.1722 9.68138C28.9852 6.81568 26.9751 4.36633 24.396 2.64306ZM11.5917 10.9553C11.9041 10.6433 12.0797 10.2199 12.0799 9.77839C12.0801 9.33687 11.9049 8.91334 11.5929 8.60098C11.2808 8.28862 10.8575 8.11301 10.416 8.11279C9.97444 8.11257 9.55092 8.28776 9.23855 8.5998C8.92619 8.91185 8.75059 9.33521 8.75037 9.77673C8.75015 10.2183 8.92533 10.6418 9.23738 10.9541C9.54943 11.2665 9.97278 11.4421 10.4143 11.4423C10.8558 11.4426 11.2794 11.2674 11.5917 10.9553ZM8.80031 12.6751H12.1298V23.0965H8.80031V12.6751ZM14.0776 12.6751H17.3905L17.3572 14.0735C18.739 11.5514 24.6156 11.3599 24.6156 16.4957V23.0965H21.3277V17.6278C21.3277 14.2982 17.3572 14.5813 17.3572 17.6278V23.0965H14.0776V12.6751Z",
    fill: "#74767D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_1318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.367,
    height: 31.367,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.a259032d23edf216297e2d589de27a9d.svg";
export { ForwardRef as ReactComponent };